<template>
	<Auth title="Reset Password">
		<template #heading>
			<h1 class="fw-bold mb-2">Reset Password</h1>
			<p class="fw-medium text-muted">Input your new password.</p>
		</template>
		<Alert ref="alert" class="alert-danger">
			{{ message }}
		</Alert>
		<Form ref="form" @submit="onSubmit">
			<div class="mb-2">
				<label for="password" class="text-dark text-sm fw-semibold mb-1">New Password</label>
				<InputField id="password" v-model="password" name="password" rules="required|min:4" label="Password" type="password" placeholder="password" />
			</div>
			<div class="mb-2">
				<InputField id="password_confirmation" v-model="password_confirmation" name="password_confirmation" rules="required|min:4" label="Confirm Password" type="password" placeholder="confirm password" />
			</div>

			<div class="d-flex flex-column justify-content-between align-items-center mb-4">
				
				<div class="w-100">
					<Button id="action" type="submit" :label="labels" :loading="loading" :done="done" :disabled="checkInput" class="btn bg-secondary text-light py-3 w-100" />
				</div>
				<div class="w-100">
					<Link :href="route('login')" class="text-muted fs-sm fw-medium d-block d-lg-inline-block mt-2">Goto login page</Link>
				</div>
			</div>
		</Form>
	</Auth>
</template>

<script lang="ts">
import { error } from '@/ts/app'
import Alert from '@/vue/components/Alert.vue'
import Button from '@/vue/components/Button.vue'
import Form from '@/vue/components/Form.vue'
import InputField from '@/vue/components/InputField.vue'
import Link from '@/vue/components/Link.vue'
import Auth from '@/vue/templates/Auth.vue'
import { ButtonLabel } from '@/vue/utils/Button'
import { AxiosError } from 'axios'
import { Component, Prop, Ref, Vue, Watch, toNative } from 'vue-facing-decorator'

@Component({
	components: {
		Auth,
		Alert,
		InputField,
		Form,
		Button,
		Link,
	},
})
class ResetPassword extends Vue {
	message = ''

	password = ''
	password_confirmation = ''

	loading = false
	done = false

	@Ref('form')
	readonly form!: InstanceType<typeof Form>

	@Ref('alert')
	readonly alert!: InstanceType<typeof Alert>

	@Prop({ type: String })
	readonly email!: string

	@Watch('message')
	onMessageChanged(value: string) {
		const alert: HTMLDivElement = this.alert.$el
		if (value.length > 0) {
			alert.classList.add('show')
		} else {
			alert.classList.remove('show')
		}
	}

	get labels(): ButtonLabel {
		return {
			normal: 'Reset',
			loading: 'Resetting',
			done: 'Done',
		} as ButtonLabel
	}
	get checkInput(): boolean {
	return this.password.trim() === '' || this.password_confirmation.trim() === ''
	}

	async onSubmit(payload) {
		this.loading = true
		this.message = ''
		payload = {
			...payload,
			email: this.email,
		}
		this.$http
			.post(this.route('auth.ajax.password.reset'), payload)
			.then(() => {
				this.done = true
				this.$sweet.fire({
					title: 'Success!',
					text: 'Password updated successfully.',
					icon: 'success',
					confirmButtonText: 'OK',
				}).then(() => {
					this.$router.replace(this.route('login'))
				})
			})
			.catch((e: AxiosError) => error(e, this))
			.finally(() => (this.loading = false))
	}
}

export default toNative(ResetPassword)
</script>
